import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedTime } from 'react-intl';
import { DateStyles } from '../../constants/CentricConstants';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';

class ModuleEventAssignmentDialog extends Component {

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
        this.onEventSelect = this.onEventSelect.bind(this);
    }

    render() {

        const dialogProps = {
            title:          "Assign to event",
            open:           true,
            modal:          true,
            onRequestClose: this.props.onClose,
            actions: [
                <FlatButton key="cancel" label="Cancel" onTouchTap={this.props.onCancel} />,
                <FlatButton key="submit" label="Assign" onTouchTap={this.onSave} disabled={!this.state.draft.eventId} />
            ]
        };

        const events = this.props.events.map(({id, name, timeStart, venue}) => {
            const start = new Date(timeStart);
            const text = (
                <span>
                    <FormattedDate {...DateStyles.shortWeekday} value={start} /> at <FormattedTime value={start} />
                    {!!venue && ` - ${venue}`}
                </span>
            );

            return (<MenuItem key={id} value={id} primaryText={text} />);
        });

        return (
            <Dialog {...dialogProps} >
                <SelectField
                    name="eventId"
                    floatingLabelText="Event"
                    value={this.state.draft.eventId}
                    onChange={this.onEventSelect}
                    errorText={!this.state.draft.eventId && "Required field"}
                    fullWidth={true}
                >
                    {events}
                </SelectField>
                <div>
                    Attendees: <span>{this.state.draft.users.map(user => user.name).join('; ')}</span>
                </div>
            </Dialog>
        );
    }

    onEventSelect({target}, index, value) {
        if (value !== this.state.draft.eventId) {
            DialogActions.updateDraft('eventId', value);
        }
    }

    onSave() {
        const saved = this.props.onSave(this.state.draft);
        if (saved !== false && !!this.props.closeOnSave) { this.props.onClose(); }
    }
}

ModuleEventAssignmentDialog.getStores = () => ([DialogStore]);
ModuleEventAssignmentDialog.calculateState = (prevState) => (DialogStore.getState());

ModuleEventAssignmentDialog.propTypes = {
    userList:       PropTypes.arrayOf(
        PropTypes.shape({
            id:     PropTypes.number,
            name:   PropTypes.string
        })
    ),

    events:         PropTypes.arrayOf(
        PropTypes.shape({
            id:     PropTypes.number,
            name:   PropTypes.string
        })
    ),
    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool
};

ModuleEventAssignmentDialog.defaultProps = {
    onClose:        DialogActions.close,
    onCancel:       DialogActions.close,
    onSave:         () => true,
    closeOnSave:    true
};

export default Container.create(ModuleEventAssignmentDialog);
